import { Model } from '@vuex-orm/core'
import SchoolLink from './misc/schoolLinks.js'
import Schools from 'src/api/schools.js'
import SduiPlus from 'src/api/sduiPlus.js'

export class Partner extends Model {
  static entity = 'partner'
  static fetchUrl = (id) => SduiPlus.sduiPlusByIdUrl(id)
  static fetchAllUrl = () => `${SduiPlus.sduiPlusUrl()}?&`

  static fields () {
    return {
      visibility_subtitle: this.string(''),
      uuid: this.string(null),
      title: this.string(''),
      subtitle: this.string('').nullable(),
      company_name: this.string('').nullable(),
      pitch: this.string('').nullable(),
      icon: this.string('').nullable(),
      image: this.string('').nullable(),
      description: this.string('').nullable(),
      privacy_text: this.string('').nullable(),
      privacy_url: this.string('').nullable(),
      privacy_option_0: this.string('').nullable(),
      privacy_option_1: this.string('').nullable(),
      privacy_option_2: this.string('').nullable(),
      privacy_option_3: this.string('').nullable(),
      link_url: this.string('').nullable(),
      link_description: this.string('').nullable(),
      link_color: this.string('').nullable(),
      link_filters: this.string('').nullable(),
      updated_at: this.attr(null),
      created_at: this.attr(null),
      can: this.attr({}),
      school_links: this.hasMany(SchoolLink, 'partner_uuid'),
      meta: this.attr({})
    }
  }

  static async deleteSchoolLink (schoolUuid, partnerUuid) {
    await Schools.deletePartner(schoolUuid, partnerUuid)
  }

  static async addSchoolLink (schoolUuid, partnerUuid) {
    await Schools.postPartner(schoolUuid, partnerUuid)
  }
}
